module.exports = __webpack_public_path__ + "static/media/control-next.72d20d5b.svg";